import { Fragment } from 'react';
import AssignPartnerPatientKey from './AssignPartnerPatientKey';
import Overlay from '../../../components/Overlay';
import { TableUser } from '../UsersList';

const UserListInterfaceBody = ({ users, setUsers, label, user }: {users: TableUser[], user: TableUser, setUsers: React.Dispatch<React.SetStateAction<TableUser[]>>, label: string}) => {
  const partnerPatientKey: string = user.partnerPatientKey;
  return (
    <Fragment>
      <Overlay
        style={{ width: '400px' }}
        className={partnerPatientKey ? 'p-button-text' : ''}
        label={label}
      >
        <AssignPartnerPatientKey user={user} users={users} setUsers={setUsers} />
      </Overlay>
    </Fragment>
  )
};

export default UserListInterfaceBody;
